var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-overlay',{staticClass:"loading",attrs:{"show":true}},[_c('img',{attrs:{"src":"//m.mlszp.com/img/logo2.png","alt":""}}),_c('van-loading',{attrs:{"size":"110px","color":"#fe5900"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }